import {
  SYSTEM_ERROR_CATEGORIES as SharedCategories,
  SYSTEM_ERROR_CODES as SharedCodes,
} from 'shared/dist/types/SystemError';

import type {
  SystemError as SharedSystemError,
  SystemErrorCategory,
  SystemErrorCode,
} from 'shared/dist/types/SystemError';

export type { SystemErrorCategory, SystemErrorCode };

export const SYSTEM_ERROR_CATEGORIES = SharedCategories;
export const SYSTEM_ERROR_CODES = SharedCodes;

export default interface SystemError extends SharedSystemError {}
